import { VFC } from "react";
import { NodeInstance, NodeType } from "src/types/node.types";
import { NodeTypeSelection } from "./node-type-selection";
import { useToggle } from "react-use";
import { nodeDefs } from "src/nodes";
import { Dialog } from "src/components/dialog";
import { css } from "src/styles/theme";
import { Cross1Icon } from "@radix-ui/react-icons";

export interface EditableNodeTypeProps {
  node: NodeInstance;
  onChange: (node: NodeInstance) => void;
}

export const EditableNodeType: VFC<EditableNodeTypeProps> = (props) => {
  const [isModalOpen, toggleModal] = useToggle(false);
  const nodeDef = nodeDefs[props.node.type];

  const onTypeChangeHandler = (type: NodeType) => {
    toggleModal();
    if (type === props.node.type) return;
    const newConfig = nodeDefs[type];
    const newNode = newConfig.create();
    newNode.id = props.node.id;
    newNode.name = props.node.name;
    props.onChange(newNode);
  };

  return (
    <Dialog.Root open={isModalOpen}>
      <Dialog.Trigger onClick={toggleModal} className={cn.trigger()}>
        {nodeDef.shortDisplayName || nodeDef.displayName}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay onClick={toggleModal} />
        <Dialog.Content onEscapeKeyDown={toggleModal}>
          <Dialog.ContentHeader>
            <Dialog.Title>Change node type</Dialog.Title>
            <Dialog.Description>
              The node is currently of type{" "}
              <strong>{nodeDef.displayName}</strong>. Choose a new type to
              change it.
            </Dialog.Description>
            <Dialog.Close onClick={toggleModal} aria-label="Close">
              <Cross1Icon />
            </Dialog.Close>
          </Dialog.ContentHeader>
          <Dialog.ContentBody>
            <NodeTypeSelection
              type={props.node.type}
              onChange={onTypeChangeHandler}
            />
          </Dialog.ContentBody>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

const cn = {
  trigger: css({
    applyReset: "btn",
    padding: "0 $3",
    borderRadius: "$2",
    color: "$primaryText",
    fontSize: "$sm",
    fontWeight: "$medium",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    userSelect: "none",

    "&:hover, &:focus": {
      outline: 0,
      backgroundColor: "$primaryBg",
    },
  }),
};
